export default {
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',

  // Users
  'menu.users': 'Users',
  'menu.users.list': 'User List',
  'menu.users.wallets': 'Wallet Connections',
  'menu.users.detail': 'User Detail',

  // Miners
  'menu.miners': 'Miners',
  'menu.miners.products': 'Products',

  // Farms
  'menu.farms': 'Farms',
  'menu.farms.types': 'Farm List',

  // Orders
  'menu.orders': 'Orders',

  // Tickets
  'menu.tickets': 'Tickets',
  'menu.tickets.products': 'Ticket Products',

  // Withdrawals
  'menu.withdrawals': 'Withdrawals',
  'menu.withdrawals.pending': 'Pending',
  'menu.withdrawals.history': 'History',

  // Activities
  'menu.activities': 'Activities',
  'menu.activities.dailyPool': 'Daily Pool',
  'menu.activities.dailyPoolDetail': 'Daily Pool Detail',
  'menu.activities.social': 'Social Events',
  'menu.activities.socialDetail': 'Social Event Detail',
  'menu.activities.promotions': 'Promotions',

  // Messages
  'menu.messages': 'Messages',
  'menu.messages.list': 'Message List',
  'menu.messages.send': 'Send Message',

  // Analytics
  'menu.analytics': 'Analytics',

  // Channels
  'menu.channels': 'Channels',

  // Transactions
  'menu.transactions': 'Transactions',

  // Payments
  'menu.payments': 'Payments',
  'menu.payments.unmatched': 'Unmatched Payments',
  'menu.reconciliation': 'Reconciliation',

  // Settings
  'menu.settings': 'Settings',

  // System Admin
  'menu.system': 'System',
  'menu.system.accounts': 'Accounts',
  'menu.system.roles': 'Roles',

  // Account
  'menu.account': 'Account',
  'menu.account.logout': 'Logout',

  // Exceptions
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
